export const createAlert = (isError, message, parentClass, referenceElem) => {
  let alert = document.querySelector(`${parentClass} .notification`)
  if (!alert) {
    alert = document.createElement('div')
    document.querySelector(parentClass).insertBefore(alert, document.querySelector(referenceElem))
  }
  alert.className = `notification is-light ${!isError ? 'is-success' : 'is-danger'}`
  alert.innerHTML = message

  if (!isError) {
    document.querySelector(referenceElem).classList.add('is-hidden')
  }
}

export const renderErrors = (errors, parent = '', dynamicName = false) => {
  if (parent) {
    removeItems(`${parent} .notification`)
    removeItems(`${parent} .help.is-danger`)
  }
  Object.keys(errors).forEach(error => {
    let errorHolder = document.querySelector(`.${error}-error`)
    let selector = `[name=${error}]`

    if (dynamicName) {
      selector = `#${dynamicName}_${error}`
    }
    if (!errorHolder || errorHolder === null) {
      const parentHolder = document.querySelector(selector).parentElement
      errorHolder = document.createElement('div')
      errorHolder.className = `notification is-light ${error}-error`
      parentHolder.appendChild(errorHolder)
    }
    errorHolder.innerHTML = errors[error].errors
  })
}

const removeItems = selector => {
  document.querySelectorAll(selector).forEach(elem => { console.log(elem); elem.remove() })
}
